import { render, staticRenderFns } from "./comentarios.vue?vue&type=template&id=2fb69d8c&scoped=true&"
import script from "./comentarios.component.ts?vue&type=script&lang=ts&"
export * from "./comentarios.component.ts?vue&type=script&lang=ts&"
import style0 from "./comentarios.vue?vue&type=style&index=0&id=2fb69d8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb69d8c",
  null
  
)

export default component.exports